/* Ambassador process timeline: steps light up and the line between them fills as you scroll. */
(() => {
  if (window.lsAmbLoaded) return;
  window.lsAmbLoaded = true;
  /* Links to #smile-<deep link> open that Smile.io panel; without Smile they do nothing harmful. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest?.('a[href^="#smile-"]');
    if (!a || !window.SmileUI?.openPanel) return;
    e.preventDefault();
    window.SmileUI.openPanel({ deep_link: a.getAttribute('href').slice(7) });
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root) => {
    if (root.dataset.lsaReady || reduced.matches || window.Shopify?.designMode) return;
    root.dataset.lsaReady = '1';
    const steps = [...root.querySelectorAll('[data-lsa-step]')];
    if (!steps.length || !('IntersectionObserver' in window)) return;
    root.classList.add('lsa-js');
    let reached = -1;
    const paint = () => steps.forEach((el, i) => {
      el.classList.toggle('is-on', i <= reached);
      el.classList.toggle('is-done', i < reached);
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const i = steps.indexOf(entry.target);
        if (entry.isIntersecting) reached = Math.max(reached, i);
        else if (entry.boundingClientRect.top > 0 && i <= reached) reached = i - 1;
      });
      paint();
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
    steps.forEach((el) => io.observe(el));
  };
  const reveal = (el) => {
    if (el.dataset.lsaReady) return;
    el.dataset.lsaReady = '1';
    if (reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    if (el.getBoundingClientRect().top < window.innerHeight) return;
    el.classList.add('lsa-reveal');
    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      el.classList.add('is-in');
      io.disconnect();
    }, { rootMargin: '0px 0px -12% 0px' });
    io.observe(el);
  };
  const run = () => {
    document.querySelectorAll('[data-lsa-process]').forEach(init);
    document.querySelectorAll('[data-lsa-reveal]').forEach(reveal);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
